import React, { useState, useEffect } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

const OnboardingCTA = ({ visible }) => {
  const navigate = useNavigate();

  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const syncState = () => {
      const dismissed =
        sessionStorage.getItem("onboarding_cta_closed") === "true";

      const started =
        sessionStorage.getItem("onboarding_started") === "true";

      setHidden(dismissed || started);
    };

    syncState();

    window.addEventListener("storage-sync", syncState);

    return () => {
      window.removeEventListener("storage-sync", syncState);
    };
  }, []);

  const handleClose = () => {
    sessionStorage.setItem("onboarding_cta_closed", "true");

    setHidden(true);

    window.dispatchEvent(new Event("storage-sync"));
  };

  if (!visible || hidden) return null;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.close} onClick={handleClose}>
          ×
        </div>

        <h4 style={{ margin: 0 }}>Setup Your Company ⚡</h4>

        <p style={{ fontSize: 12, margin: "6px 0 12px" }}>
          Complete initial setup to unlock full features.
        </p>

        <Button
          type="primary"
          block
          onClick={() => {
            sessionStorage.setItem("onboarding_started", "true");

            window.dispatchEvent(new Event("storage-sync"));

            navigate(
              "/settings/institution-profile?onboarding=true&manual=true"
            );
          }}
        >
          Start Setup
        </Button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: "fixed",
    bottom: 90,
    right: 20,
    zIndex: 1005, // below wizard (1010), above UI
  },
  card: {
    width: 260,
    background: "#fff",
    padding: 14,
    borderRadius: 10,
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    position: "relative",
  },
  close: {
    position: "absolute",
    top: 2,
    right: 12,
    cursor: "pointer",
    fontSize: 22,
    color: "#999",
  },
};


export default OnboardingCTA

